// Configuration.js
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { View, Text, ScrollView } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import dr from './../datosReferenciales.json';
import transl from '../translations/transl';

// Action de Redux
const setLanguage = (langIndex) => ({
  type: 'SET_LANGUAGE',
  language: langIndex
});

const Configuration = () => {
  const navigation     = useNavigation();
  const reduxLangIndex = useSelector((state) => state.language);
  const langCode       = dr.idiomas[reduxLangIndex]?.value || dr.idiomas[0].value;

  // 1) Estados de valores
  const [valueSpeed,  setValueSpeed]  = useState(null);
  const [valueLang,   setValueLang]   = useState(null);
  const [valueEndBtn, setValueEndBtn] = useState(null);
  const [valueInj,    setValueInj]    = useState(null);
  const [valueTheme,  setValueTheme]  = useState(null);

  // 2) Estados de open/close
  const [openSpeed,   setOpenSpeed]   = useState(false);
  const [openLang,    setOpenLang]    = useState(false);
  const [openEndBtn,  setOpenEndBtn]  = useState(false);
  const [openInj,     setOpenInj]     = useState(false);
  const [openTheme,   setOpenTheme]   = useState(false);

  // 3) Estados de items
  const [itemsSpeed,  setItemsSpeed]  = useState([]);
  const [itemsLang,   setItemsLang]   = useState([]);
  const [itemsEndBtn, setItemsEndBtn] = useState([]);
  const [itemsInj,    setItemsInj]    = useState([]);
  const [itemsTheme,  setItemsTheme]  = useState([]);

  //
  // Carga inicial (solo al montar)
  //
  useEffect(() => {
    (async () => {
      const raw = await AsyncStorage.getItem('equipos');
      if (!raw) return;
      const data = JSON.parse(raw);
      setValueSpeed(data.settings.comentarySpeed);
      setValueLang(data.settings.language);
      setValueEndBtn(data.settings.backButtonAbled ? 1 : 0);
      setValueInj(data.settings.informInjuries ? 1 : 0);
      setValueTheme(data.settings.darkTheme ? 1 : 0);
    })();
  }, []);

  //
  // Guardar en AsyncStorage al cambiar cualquiera
  //
  useEffect(() => {
    if ([valueSpeed, valueLang, valueEndBtn, valueInj, valueTheme]
        .some(v => v === null)) return;

    (async () => {
      const raw = await AsyncStorage.getItem('equipos');
      const data = raw ? JSON.parse(raw) : { settings: {} };
      data.settings = {
        comentarySpeed:  valueSpeed,
        language:        valueLang,
        backButtonAbled: !!valueEndBtn,
        informInjuries:  !!valueInj,
        darkTheme:       !!valueTheme
      };
      await AsyncStorage.setItem('equipos', JSON.stringify(data));
    })();
  }, [valueSpeed, valueLang, valueEndBtn, valueInj, valueTheme]);

  //
  // Regenerar labels al cambiar langCode
  //
  useEffect(() => {
    setItemsSpeed([
      { label: transl('Configuration.rapida', langCode), value: 0 },
      { label: transl('Configuration.normal', langCode), value: 1 },
      { label: transl('Configuration.lenta',  langCode), value: 2 }
    ]);

    setItemsLang(
      dr.idiomas.map((d, i) => ({
        label: d.label,
        value: i,
        disabled: i === 2   // <-- aquí marcas el tercer idioma como no seleccionable
      }))
    );

    setItemsEndBtn([
      { label: transl('Configuration.activoAlAcabar', langCode), value: 0 },
      { label: transl('Configuration.siempreActivo',    langCode), value: 1 }
    ]);

    setItemsInj([
      { label: transl('Configuration.noAvisarme', langCode), value: 0 },
      { label: transl('Configuration.avisarme',   langCode), value: 1 }
    ]);

    setItemsTheme([
      { label: transl('Configuration.claro',  langCode), value: 0 },
      { label: transl('Configuration.oscuro', langCode), value: 1, disabled: true }
    ]);
  }, [langCode]);

  //
  // Header reactivo
  //
  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: transl('MainMenu.configuracion', langCode)
    });
  }, [langCode, navigation]);

  return (
    <ScrollView>
      <View>
        <View style={{marginHorizontal:25,marginTop:25}}>
          <Text style={{fontSize:16,marginBottom:5}}>{transl('Configuration.velocidadComentarioTitle',langCode)}:</Text>
          <View>
            <DropDownPicker
                  open={openSpeed}
                  value={valueSpeed}
                  items={itemsSpeed}
                  setOpen={setOpenSpeed}
                  setValue={setValueSpeed}
                  setItems={setItemsSpeed}
                  disableBorderRadius={true}
                  zIndex={3000}
                  style={{backgroundColor: "#f2f2f2",borderRadius:0}}
                  listItemContainerStyle={{backgroundColor: "#f2f2f2"}}
                  listItemLabelStyle={{backgroundColor: "#f2f2f2"}}
                  selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
                  selectedItemLabelStyle={{backgroundColor: "#cccccc"}}
                  dropDownContainerStyle={{borderRadius:0}}
                  listMode="SCROLLVIEW"
              />
              <Text style={{fontSize:16,marginBottom:5,marginTop:25}}>{transl('Configuration.idioma',langCode)}:</Text>
              <DropDownPicker
                  open={openLang}
                  value={valueLang}
                  items={itemsLang}
                  setOpen={setOpenLang}
                  setValue={setValueLang}
                  setItems={setItemsLang}
                  disableBorderRadius={true}
                  zIndex={2000}
                  style={{backgroundColor: "#f2f2f2",borderRadius:0}}
                  listItemLabelStyle={{backgroundColor: "#f2f2f2"}}
                  listItemContainerStyle={{backgroundColor: "#f2f2f2"}}
                  selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
                  selectedItemLabelStyle={{backgroundColor: "#cccccc"}}
                  dropDownContainerStyle={{borderRadius:0}}
                  disabledItemLabelStyle={{opacity: 0.5}}
                  listMode="SCROLLVIEW"
              />
              <Text style={{fontSize:16,marginBottom:5,marginTop:25}}>{transl('Configuration.botonTerminarTitle',langCode)}:</Text>
              <DropDownPicker
                  open={openEndBtn}
                  value={valueEndBtn}
                  items={itemsEndBtn}
                  setOpen={setOpenEndBtn}
                  setValue={setValueEndBtn}
                  setItems={setItemsEndBtn}
                  disableBorderRadius={true}
                  zIndex={1000}
                  style={{backgroundColor: "#f2f2f2",borderRadius:0}}
                  listItemLabelStyle={{backgroundColor: "#f2f2f2"}}
                  listItemContainerStyle={{backgroundColor: "#f2f2f2"}}
                  selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
                  selectedItemLabelStyle={{backgroundColor: "#cccccc"}}
                  dropDownContainerStyle={{borderRadius:0}}
                  disabledItemLabelStyle={{opacity: 0.5}}
                  listMode="SCROLLVIEW"
              />
              <Text style={{fontSize:16,marginBottom:5,marginTop:25}}>{transl('Configuration.lesionesTitle',langCode)}:</Text>
              <DropDownPicker
                  open={openInj}
                  value={valueInj}
                  items={itemsInj}
                  setOpen={setOpenInj}
                  setValue={setValueInj}
                  setItems={setItemsInj}
                  disableBorderRadius={true}
                  zIndex={500}
                  style={{backgroundColor: "#f2f2f2",borderRadius:0}}
                  listItemLabelStyle={{backgroundColor: "#f2f2f2"}}
                  listItemContainerStyle={{backgroundColor: "#f2f2f2"}}
                  selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
                  selectedItemLabelStyle={{backgroundColor: "#cccccc"}}
                  dropDownContainerStyle={{borderRadius:0}}
                  disabledItemLabelStyle={{opacity: 0.5}}
                  listMode="SCROLLVIEW"
              />
              <Text style={{fontSize:16,marginBottom:5,marginTop:25}}>{transl('Configuration.tema',langCode)}:</Text>
              <DropDownPicker
                  open={openTheme}
                  value={valueTheme}
                  items={itemsTheme}
                  setOpen={setOpenTheme}
                  setValue={setValueTheme}
                  setItems={setItemsTheme}
                  disableBorderRadius={true}
                  zIndex={250}
                  style={{backgroundColor: "#f2f2f2",borderRadius:0}}
                  listItemLabelStyle={{backgroundColor: "#f2f2f2"}}
                  listItemContainerStyle={{backgroundColor: "#f2f2f2"}}
                  selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
                  selectedItemLabelStyle={{backgroundColor: "#cccccc"}}
                  dropDownContainerStyle={{borderRadius:0}}
                  disabledItemLabelStyle={{opacity: 0.5}}
                  listMode="SCROLLVIEW"
              />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default Configuration;
